// extracted by mini-css-extract-plugin
export default {"languagesSelector":"translations_languagesSelector__5kzc0"};